import { Stack } from "@mui/material";
import { useFormat } from "@sinch/core/hooks/format";

import { rejectFalsy } from "@sinch/utils/array";
import { isNotNilOrEmpty } from "ramda-adjunct";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AttributeValue } from "../../Attribute/AttributeValue";
import { StaffFragment } from "@sinch/components/application/StaffDetailPanel/queries.types";
import { DataPair } from "../types";
import { FormSecondTitle } from "@sinch/components/typography/FormSecondTitle/FormSecondTitle";

interface WalletProps {
  staff: StaffFragment;
}

export const Wallet: FC<WalletProps> = ({ staff }) => {
  const { t } = useTranslation();
  const { num } = useFormat();

  const walletDataPairs = rejectFalsy([
    {
      label: t("Staff.walletBalance"),
      value: num.currency(staff.walletStatistics.balance),
    },
    {
      label: t("Staff.paidThisMonth"),
      value: num.currency(staff.walletStatistics.paidThisMonth),
    },
    {
      label: t("Staff.paidTotal"),
      value: num.currency(staff.walletStatistics.paidTotal),
    },
    {
      label: t("Staff.requested"),
      value: num.currency(staff.walletStatistics.paidTotal),
    },
  ]);

  return (
    <Stack>
      <FormSecondTitle title={t("Staff.wallet")} />
      {(walletDataPairs as DataPair[])
        .filter(({ value }) => isNotNilOrEmpty(value))
        .map((pair) => (
          <AttributeValue key={pair.label + pair.value} label={pair.label} value={pair.value} />
        ))}
    </Stack>
  );
};
